// TODO PP-16776: move LoggedInWeb/utils/subject here once we complete webpack LoggedInWeb migration

export * from '../../LoggedInWeb/utils/subject';
